var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationMarker = function SvgLocationMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.062 4.859a8.4 8.4 0 0 1 11.88 11.88l-5.94 5.939-5.94-5.94a8.4 8.4 0 0 1 0-11.88m5.94 8.34a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
    clipRule: "evenodd"
  })));
};
export default SvgLocationMarker;